module.exports = __webpack_public_path__ + "static/media/EmpresasParceiras.f3379b60.png";